<template>
  <div class="column q-mx-auto">
    <div class="row q-mx-auto items-center">
      <q-card square bordered class="login-card q-mx-auto q-my-auto shadow-1">
        <div class="full-width justify-center flex">
          <q-img :src="retrieveAsset(require('../../assets/logo.png'))" width="50px" class="q-mx-auto"/>
        </div>
        <q-card-section>
          <div class="q-mt-sm q-mx-xl login-form">
            <q-input type="password" v-model="new_password" :label="gettext('New')" outlined stack-label dense />
              <password-meter :password="new_password" @score="evaluateScore"/>
                <q-input type="password" v-model="confirm_new" :label="gettext('Confirm')" outlined stack-label dense >
                  <template #append>
                    <q-icon :name="password_icon_name" :class="password_icon_class"/>
                  </template>
                </q-input>
                <div>
                  <ul class="password_rules">
                    <li>
                      <q-icon :name="password_icon_name" :class="password_icon_class"/>
                        <span v-if="password_confirm_rule">{{ gettext('Your two password matches')}}</span>
                        <span v-else>{{gettext("Your two password don't match")}}</span>
                    </li>
                    <li>
                      <q-icon :name="password_score_name" :class="password_score_class"/>
                        <span v-if="password_strong">{{gettext('Your password is enough strong')}}</span>
                        <span v-else>{{ gettext('Your password is too weak') }}</span>
                    </li>
                  </ul>
                </div>
          </div>
        </q-card-section>
        <q-card-actions align="center">
          <q-btn :disabled="!(password_strong && password_confirm_rule)" @click="updatePassword()">{{gettext('Update')}}</q-btn>
        </q-card-actions>
      </q-card>
    </div>
  </div>
</template>

<script>
import dj_i18n from "@/services/django_i18n";
import LoginService from "@/services/rest-auth";
import { mapStores } from 'pinia';
import { useUserTokenStore } from '@/store/usertoken';   
import utils from '@/components/utils';
import PasswordMeter from 'vue-simple-password-meter';
import { useQuasar } from 'quasar';
import {mdiCheck, mdiAlertCircle } from '@quasar/extras/mdi-v6'; 

export default {
  name: "PasswordResetConfirmForm",
  components: {PasswordMeter},
  mixins: [dj_i18n, utils],

  setup() {
    const $q = useQuasar();
     return { 
      retrieveAsset : utils.retrieveAsset,
      convertJsonToMessage : utils.convertJsonToMessage,
      mdiCheck,
      mdiAlertCircle,
      showNotif(msg) {
        $q.notify(msg);
      }    
    }
  },

  data: () => ({
    password: null,
    new_password:null,
    confirm_new:null,
    password_score:0,
  }),
  
  methods: {
    evaluateScore(evaluation) {
      this.password_score = evaluation.score;
    },
    updatePassword() {
      const self = this;
      const payloadConfirm = {
        uid: self.$route.params.uid,
        token: self.$route.params.token,
        new_password: self.new_password 
      }
      LoginService.reset(payloadConfirm).then(function(response) {
        console.log(response);
        self.showNotif(self.gettext('Password changed'));
        self.new_password = null;
        self.password = null;
        self.confirm_new = null;
        self.password_score = 0;
        setTimeout(() => self.$router.push('/accounts/login'), 500);
        }).catch(function(error){
          console.error(error);
          self.showNotif(self.gettext("failed to change password"));
          self.password_confirmation = null;
        });
      }
    },
  computed: {
    ...mapStores(useUserTokenStore),
    password_icon_name() {
      if (this.password_confirm_rule)
        return mdiCheck;
      return mdiAlertCircle;
    },
    password_icon_class(){
      return {
        'text-green':this.password_confirm_rule,
        'text-red': !this.password_confirm_rule
      }
    },
    password_confirm_rule() {
      return this.new_password && this.new_password === this.confirm_new;
    },
    password_score_name() {
      if(this.password_strong)
        return mdiCheck;
      return mdiAlertCircle;
    },
    password_score_class(){
      return {
        'text-green': this.password_strong,
        'text-red':!this.password_strong,
      }
    },
    password_strong() {
      return this.password_score > 3;
    },
  }
};
</script>
<style lang="scss">
.login-card {
  min-width:50%;
}

.login-form {
  max-width:75%;
}
.hidden {
  width:1px;
  height:1px;
}
.po-password-strength-bar {
  border-radius: 2px;
  transition: all 0.2s linear;
  height: 5px;
  margin-top: 8px;
}

.po-password-strength-bar.risky {
  background-color: #f95e68;
  width: 10%;
}

.po-password-strength-bar.guessable {
  background-color: #fb964d;
  width: 32.5%;
}

.po-password-strength-bar.weak {
  background-color: #fdd244;
  width: 55%;
}

.po-password-strength-bar.safe {
  background-color: #b0dc53;
  width: 77.5%;
}

.po-password-strength-bar.secure {
  background-color: #35cc62;
  width: 100%;
}
.password_rules {
  list-style-type:none;
}


</style>
